export enum UserComplianceSearchStatus {
    ACTIVE = 0,
    ALL = 1,
    ARCHIVED = 2,
}